import { useState } from 'react';
import { createCheckoutSession } from '../../api/api';
import { toast } from 'react-hot-toast';
import { handleApiError } from '../../helpers/handleApiError';

export default function GetStartedButton({ packageId, forceLoading = false }) {
  const [loading, setLoading] = useState(false);
  const isLoading = loading || forceLoading;

  const handleCheckout = async () => {
    try {
      setLoading(true);
      const res = await createCheckoutSession(packageId);
      window.location.href = res.checkout_url;
    } catch (error) {
      handleApiError(error, 'Failed to start checkout session');

      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCheckout}
      disabled={isLoading}
      className={`w-full py-2 mt-5 rounded font-semibold text-sm transition
    ${
      isLoading
        ? 'bg-gray-400 cursor-not-allowed'
        : 'bg-brand hover:bg-brand text-white'
    }`}
    >
      {isLoading ? 'Redirecting…' : 'Get Started'}
    </button>
  );
}
